export default __webpack_public_path__ + "static/media/social-networking-app-case-study.351cc80c.png";